import O1HD from "../../../engines/gameEngine";
import data_control from "../../../engines/libs/data_control";
import spendMode from "../spendMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SpendCoin extends cc.Component {

    @property({type:cc.Label,displayName:"金币文本"})
    lb_Coin:cc.Label = null;

    start(){
        O1HD.getManagers().gameMgr.loadChaoPiaoPos(this.node.convertToWorldSpaceAR(cc.v2()));
    }

    update(){
        if(spendMode._instance){
            this.lb_Coin.string = data_control.getNumberFormat(spendMode._instance.manage.getGameData()._coin);
        }
    }

}
